import { Tooltip } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";

export const XeroExportedIcon = () => {
  return (
    <Tooltip label={t`Already imported to Xero`} shouldWrapChildren>
      <Icon name="download-02" ml="2" />
    </Tooltip>
  );
};
